<template>
  <div
    :class="['sliding-wrapper', { hideArrows }]"
    ref="slidingWrapper"
    :style="wrapperStyle"
  >
    <button
      v-if="!areArrowsOverCarousel"
      class="arrow --prev"
      v-show="
        !isStory && (numberOfVideosToDisplay < videos.length || isInPreview)
      "
      @click="prevSlide()"
    >
      <CarouselArrow
        v-if="!hideArrows"
        :arrow-settings="formatCarouselObject.arrowSettings"
      ></CarouselArrow>
    </button>
    <div
      class="vidjet-carousel-items"
      :class="[
        { 'is-story': isStory },
        { 'has-shadow': format.thumbnailShadow },
      ]"
      ref="slidingContainer"
      :style="`${gridDisplay};`"
      @mousedown="onStart"
      @mousemove="onMove"
      @mouseup="onEnd"
      @touchstart="onStart"
      @touchmove="onMove"
      @touchend="onEnd"
    >
      <iteration-section
        v-for="(video, index) in videos"
        :key="video.id"
        :video-index="index"
        :clickedInlineIndex="clickedInlineIndex"
        :card-height="cardHeight"
        :card-width="cardWidth"
        :number-of-videos-to-display="numberOfVideosToDisplay"
        class="video-not-selectable"
        :class="{ 'video-not-selectable-stories-mobile': isStory && isMobile }"
        @click-done="handleMouseDown($event)"
        @previous-video="goToPreviousVideo(index)"
      ></iteration-section>
      <iteration-section
        v-if="hasYoutubeThumbnail"
        :key="+1"
        :video-index="videos.length"
        :clickedInlineIndex="clickedInlineIndex"
        :card-height="cardHeight"
        :card-width="cardWidth"
        :number-of-videos-to-display="numberOfVideosToDisplay"
        class="video-not-selectable"
        :class="{ 'video-not-selectable-stories-mobile': isStory && isMobile }"
        @click-done="handleMouseDown($event)"
      ></iteration-section>
    </div>
    <div
      v-if="
        areArrowsOverCarousel &&
        !isStory &&
        (numberOfVideosToDisplay < videos.length || isInPreview)
      "
      class="overlay-arrows"
      :style="{
        '--overlayPad': overlayPadPx + 'px',
        '--controlsSidePadding': controlsSidePadding + 'px',
      }"
    >
      <button class="arrow --overlay --prev" @click="prevSlide()">
        <CarouselArrow
          v-if="!hideArrows"
          :arrow-settings="formatCarouselObject.arrowSettings"
        />
      </button>
      <button class="arrow --overlay --next" @click="nextSlide()">
        <CarouselArrow
          v-if="!hideArrows"
          :arrow-settings="formatCarouselObject.arrowSettings"
        />
      </button>
    </div>

    <button
      v-if="!areArrowsOverCarousel"
      class="arrow --next"
      v-show="
        !isStory && (numberOfVideosToDisplay < videos.length || isInPreview)
      "
      @click="nextSlide()"
    >
      <CarouselArrow
        v-if="!hideArrows"
        :arrow-settings="formatCarouselObject.arrowSettings"
      ></CarouselArrow>
    </button>
  </div>
</template>

<script>
import IterationSection from "./IterationSection.vue";
import SwiperVidjet from "../utils/swiper.js";
import { changeIframe } from "@/utils/utils";
import CarouselArrow from "@/components/arrows/Arrow.vue";
import enums from "@/enums.js";
const { Position } = enums;

import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "CarouselFormat",
  components: { IterationSection, CarouselArrow },
  data() {
    return {
      containerWidth: 0,
      indexOfFirstVideoDisplayed: 0,
      gridGap: 16,
      gridDisplay: "",
      cardWidth: 250,
      cardHeight: 0,
      numberOfVideosToDisplay: 0,
      controlsSidePadding: 0,
      spaceAvailableRemaining: 0,
      touchEvent: null,
      dragX: 0,
      clickedIndex: null,
      clickedInlineIndex: null,
      isBiggerVideoPlaying: false,
      dragInfo: {
        startX: 0,
        startY: 0,
        scrollLeft: 0,
        isDown: false,
        isDragging: false,
      },
      overlayPadPx: 8,
    };
  },
  props: {
    isPreview: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    isMobile() {
      this.calculateGrid();
    },
    cardHeight() {
      this.$emit("carousel-height", this.cardHeight);
    },

    isStory() {
      this.calculateGrid();
    },

    format() {
      this.calculateGrid();
    },

    indexOfFirstVideoDisplayed(newValue) {
      if (this.isStory) return;
      // check if video is still visible when index changes, if not, pause it by setting clickedIndex to null
      if (
        this.clickedInlineIndex > this.indexOfLastVisibleVideo ||
        this.clickedInlineIndex < this.indexOfFirstVideoDisplayed
      ) {
        this.clickedInlineIndex = null;
      }
      // dragging shouldn't loop carousel
      if (newValue < 0) {
        this.indexOfFirstVideoDisplayed = 0;
      } else if (newValue > this.maxIndexVideo) {
        this.indexOfFirstVideoDisplayed = this.maxIndexVideo;
      }
      this.positionCarousel();
    },

    clickedInlineIndex(newValue) {
      if (!this.isInPreview && newValue !== null) {
        const videoId = this.videos[this.clickedIndex].videoId;
        this.addAnalytics({ videoId: videoId });
        this.sendEvent({
          type: "videoDisplay",
        });
      }
      if (newValue !== null) {
        this.setCurrentIndex(newValue);
      }

      this.isBiggerVideoPlaying = false;
      if (newValue !== null && this.numberOfVideosToDisplay > 1) {
        this.moveVideoWhenGrowing(newValue);
      }
      // if video is not visible, scroll to it
      if (
        this.clickedInlineIndex !== null &&
        this.clickedInlineIndex > this.indexOfLastVisibleVideo
      ) {
        this.indexOfFirstVideoDisplayed = this.indexOfLastVisibleVideo;
      }
    },
    arrowsWidth() {
      this.calculateGrid();
    },
  },

  mounted() {
    this.calculateGrid();
    window.addEventListener("resize", () => {
      this.calculateGrid();
    });
    // this.bindSwipingListeners();
  },

  computed: {
    ...mapGetters("playerCampaign", ["format", "isStory", "position"]),
    ...mapGetters("videos", ["videos", "thumbnail", "hasYoutubeThumbnail"]),
    ...mapGetters("analytics", ["hasFlowId"]),
    ...mapGetters("player", [
      "isTablet",
      "isMobile",
      "isInPreview",
      "hasScriptLoaded",
    ]),

    numberOfVideos() {
      // when a non portrait video is playing we still need to scroll to last video
      return this.isBiggerVideoPlaying
        ? this.videos.length + 1
        : this.videos.length;
    },

    isInlined() {
      return !this.format.isFullScreen;
    },

    maxIndexVideo() {
      return this.numberOfVideos - this.numberOfVideosToDisplay;
    },

    indexOfLastVisibleVideo() {
      return this.indexOfFirstVideoDisplayed + this.numberOfVideosToDisplay - 1;
    },

    formatCarouselObject() {
      if (this.isInlined) {
        return {
          ...this.format,
        };
      }
      return {
        ...this.format,
        ...{ hidePlayPause: false, isFullScreen: false },
      };
    },

    scrollLeftWalk() {
      let walk =
        this.indexOfFirstVideoDisplayed * (this.cardWidth + this.gridGap) +
        this.dragX;
      if (this.hideArrows) {
        walk -= this.spaceAvailableRemaining;
      }
      return walk;
    },

    indexLastVideoToShow() {
      return this.indexOfFirstVideoDisplayed + this.numberOfVideosToDisplay;
    },

    isTouchable() {
      return (this.isMobile || this.isTablet) && !this.isInPreview;
    },
    arrowsWidth() {
      if (this.hideArrows) return 0;
      const bigSizeArrow = [
        "corner2",
        "corner3",
        "line2",
        "line3",
        "bold2",
        "bold3",
      ];
      if (
        bigSizeArrow.includes(this.formatCarouselObject.arrowSettings?.iconType)
      )
        return 60;
      return 35;
    },

    hideArrows() {
      return (
        (this.isMobile && !this.areArrowsOverCarousel) ||
        this.formatCarouselObject.hideCarouselArrows
      );
    },

    getProperPositioning() {
      let placeItems = "center";

      //We always want to have the elements centered on mobile
      if (this.isMobile) return placeItems;

      if (this.position === Position.left) placeItems += " start";
      else if (this.position === Position.right) placeItems += " end";

      return placeItems;
    },

    wrapperStyle() {
      let marginLeft = 0;
      let marginRight = 0;
      if (this.isPreview) {
        if (this.getProperPositioning.includes("start")) marginLeft = 32;
        else if (this.getProperPositioning.includes("end")) marginRight = 32;
      }

      const useColumnsWithArrows =
        !this.areArrowsOverCarousel &&
        !this.isStory &&
        (this.numberOfVideosToDisplay < this.videos.length || this.isInPreview);

      const paddingInline = this.areArrowsOverCarousel
        ? 0
        : this.controlsSidePadding;

      return {
        padding: `0 ${paddingInline}px`,
        placeItems: this.getProperPositioning,
        gridTemplateColumns: useColumnsWithArrows
          ? `${this.arrowsWidth}px auto ${this.arrowsWidth}px`
          : "1fr",
        marginLeft: `${marginLeft}px`,
        marginRight: `${marginRight}px`,
      };
    },
    areArrowsOverCarousel() {
      return this.formatCarouselObject.arrowsOverCarousel;
    },
    isBigOverlayArrow() {
      const big = ["corner2", "corner3", "line2", "line3", "bold2", "bold3"];
      return big.includes(this.formatCarouselObject.arrowSettings?.iconType);
    },
  },

  methods: {
    // Helper methods
    ...mapMutations({
      addAnalytics: "analytics/ADD_ANALYTICS",
      setCurrentIndex: "videos/SET_CURRENT_INDEX",
    }),
    ...mapActions({
      sendEvent: "analytics/sendEvent",
    }),
    calculateGridWidth() {
      const sideArrowsVisible =
        !this.areArrowsOverCarousel &&
        !this.isStory &&
        (this.numberOfVideosToDisplay < this.videos.length || this.isInPreview);

      const controlWidth = sideArrowsVisible
        ? this.arrowsWidth * 2 + this.gridGap * 2
        : 0;

      return this.containerWidth - controlWidth;
    },

    calculateNumberOfVideosToDisplay(gridWidth) {
      return Math.floor(gridWidth / (250 + this.gridGap));
    },

    calculateSpaceAvailable(gridWidth) {
      return gridWidth - this.gridGap * 2;
    },

    calculateCarouselWidth() {
      // check if there is space to display a 250px wide video
      return (
        this.numberOfVideosToDisplay * 250 +
        (this.numberOfVideosToDisplay - 1) * this.gridGap
      );
    },

    calculateControlsSidePadding(gridWidth, carouselWidth) {
      if (this.hideArrows) {
        // get the space available to display the cropped video
        this.spaceAvailableRemaining = gridWidth - carouselWidth;
      } else {
        return (gridWidth - carouselWidth) / 2;
      }
    },

    calculateGrid() {
      this.$refs.slidingWrapper &&
        (this.containerWidth = this.$refs.slidingWrapper.offsetWidth);
      let numberOfVideos = this.videos.length;

      if (this.hasYoutubeThumbnail) numberOfVideos += 1;

      if (this.isStory && !this.isMobile) {
        const storySizeWithPadding = this.format.storySize
          ? this.format.storySize + 10
          : 90;
        this.gridDisplay = `grid-template-columns: repeat(${numberOfVideos}, ${storySizeWithPadding}px); gap: 16px;`;
        return;
      }
      const gridWidth = this.calculateGridWidth();
      this.numberOfVideosToDisplay =
        this.calculateNumberOfVideosToDisplay(gridWidth);
      // display the small thumbnails only if mobile, fullscreen and option is toggled
      if (
        this.isInlined ||
        this.format.carouselThumbnailAmount === 1 ||
        !this.isMobile
      ) {
        this.displayCarouselWithBigThumbnails({ gridWidth, numberOfVideos });
      } else {
        this.displayCarouselWithSmallerThumbnails({
          gridWidth,
          numberOfVideos,
        });
      }
      !this.isInPreview && this.$emit("carousel-height", this.cardHeight);
    },

    // for inline carousel and fullscreen carousel with bigger thumbnail options
    displayCarouselWithBigThumbnails({ gridWidth, numberOfVideos }) {
      let carouselWidth = this.calculateCarouselWidth();

      if (
        (this.isInlined || this.format.carouselThumbnailAmount === 1) &&
        carouselWidth < 0
      ) {
        const spaceAvailable = this.calculateSpaceAvailable(gridWidth);
        this.numberOfVideosToDisplay = 1;
        carouselWidth = Math.max(spaceAvailable, 250);
        this.cardWidth = 250;
      } else {
        this.cardWidth = 250;
      }
      this.controlsSidePadding = this.calculateControlsSidePadding(
        gridWidth,
        carouselWidth
      );
      this.gridDisplay = `grid-template-columns: repeat(${numberOfVideos}, auto);`;
      this.cardHeight = this.cardWidth * 1.77776;
    },

    // for mobile and tablet carousel fullscreen
    displayCarouselWithSmallerThumbnails({ gridWidth, numberOfVideos }) {
      let spaceAvailable = this.calculateSpaceAvailable(gridWidth);
      this.numberOfVideosToDisplay =
        Math.floor(spaceAvailable / 3) > 150 ? 3 : 2;
      this.numberOfVideosToDisplay === 2 &&
        (spaceAvailable = spaceAvailable + this.gridGap);
      this.cardWidth = 250;
      this.controlsSidePadding = 0;
      this.gridDisplay = `grid-template-columns: repeat(${numberOfVideos}, auto)`;
      this.cardHeight = this.cardWidth * 1.77776;
    },

    handleMouseDown(index) {
      //For ixtem moto, we added another story that should perform a different action
      //We check it the index is equal to the full length
      if (index === this.videos.length) {
        return changeIframe("youtubeThumbnailClicked");
      }
      this.clickedIndex = index;
    },

    initSwipeEvent({ event }) {
      this.touchEvent = new SwiperVidjet(event, this.isTouchable);
    },

    handleTouchEvent({ event }) {
      if (!this.touchEvent) {
        return;
      }
      this.touchEvent.setEndEvent(event);
      if (!this.isInlined && this.touchEvent.getDeltaX() === 0) {
        this.toggleFullScreen(this.clickedIndex);
      } else if (this.isInlined && this.touchEvent.getDeltaX() === 0) {
        this.clickedInlineIndex = this.clickedIndex;
      } else {
        this.changeCurrentIndexToSwipedVideo();
      }
      this.positionCarousel();

      // Reset event for next touch
      this.dragX = 0;
      this.touchEvent = null;
    },

    changeCurrentIndexToSwipedVideo() {
      const swipeThresholdPercentage = this.isMobile ? 0.4 : 0.3;

      const swipeThreshold =
        swipeThresholdPercentage * (this.cardWidth + this.gridGap);
      const deltaX = this.touchEvent.getDeltaX();

      if (Math.abs(deltaX) >= swipeThreshold) {
        const adjustment =
          deltaX >= 0 ? swipeThresholdPercentage : swipeThresholdPercentage - 1;
        const numberOfPassedVideos = Math.ceil(
          Math.abs((deltaX + adjustment) / (this.cardWidth + this.gridGap))
        );

        const directionMultiplier = deltaX > 0 ? 1 : -1;
        this.indexOfFirstVideoDisplayed +=
          directionMultiplier * numberOfPassedVideos;
      }
    },

    positionCarousel() {
      const slidingContainer = this.$refs.slidingContainer;
      this.dragX = 0;
      slidingContainer.scrollTo({
        left: this.scrollLeftWalk,
        behavior: "smooth",
      });
    },

    nextSlide() {
      if (this.indexOfFirstVideoDisplayed >= this.maxIndexVideo) {
        this.indexOfFirstVideoDisplayed = 0;
      } else {
        this.indexOfFirstVideoDisplayed++;
      }
    },

    prevSlide() {
      if (this.indexOfFirstVideoDisplayed <= 0) {
        this.indexOfFirstVideoDisplayed = this.maxIndexVideo;
      } else {
        this.indexOfFirstVideoDisplayed--;
      }
    },

    isValidEvent(event) {
      return (
        event?.target?.tagName === "path" ||
        (typeof event?.target?.className === "string" &&
          (event?.target?.className.includes("vidjet-video") ||
            event?.target?.className.includes("vidjet-carousel-items") ||
            event?.target?.className.includes("wrapper")))
      );
    },
    onStart(event) {
      const slidingContainer = this.$refs.slidingContainer;

      if (this.isValidEvent(event)) {
        if (this.isStory) {
          this.startDragging(event, slidingContainer);
        } else {
          this.initSwipeEvent({ event });
        }
      }

      this.dragInfo.startX =
        event.type === "touchstart" ? event.touches[0].clientX : event.clientX;
      this.dragInfo.startY =
        event.type === "touchstart" ? event.touches[0].clientY : event.clientY;
      this.dragInfo.isDragging = true;

      if (this.isMobile) {
        this.isHorizontalDrag = false;
      }
    },

    onMove(event) {
      if (!this.dragInfo.isDragging) return;

      const currentX =
        event.type === "touchmove" ? event.touches[0].clientX : event.clientX;
      const currentY =
        event.type === "touchmove" ? event.touches[0].clientY : event.clientY;

      this.dragX = currentX - this.dragInfo.startX;
      this.dragY = currentY - this.dragInfo.startY;

      if (this.isMobile && !this.isHorizontalDrag) {
        if (
          Math.abs(this.dragX) > Math.abs(this.dragY) &&
          Math.abs(this.dragX) > 5
        ) {
          this.isHorizontalDrag = true;
        } else if (Math.abs(this.dragY) > 5) {
          this.dragInfo.isDragging = false;
          return;
        }
      }

      if (this.isMobile && this.isHorizontalDrag) {
        event.preventDefault();
      }

      const slidingContainer = this.$refs.slidingContainer;

      if (this.isStory && !this.isMobile) {
        slidingContainer.scrollLeft -= this.dragX;
        this.dragInfo.startX = currentX;
      } else if (this.isStory && this.isMobile) {
        this.dragging(event, slidingContainer);
      } else if (
        this.touchEvent !== null &&
        this.numberOfVideosToDisplay < this.videos.length
      ) {
        if (event.type === "mousemove") {
          this.dragX = this.touchEvent.startEvent.clientX - event.clientX;
        } else if (event.type === "touchmove") {
          this.dragX =
            this.touchEvent.startEvent.changedTouches[0].screenX -
            event.changedTouches[0].screenX;
        }
        slidingContainer.scrollLeft = this.scrollLeftWalk;
      }
    },

    onEnd(event) {
      this.dragInfo.isDragging = false;

      if (this.isStory) {
        this.stopDragging();
        this.toggleFullScreen(this.clickedIndex);
      } else if (this.touchEvent !== null) {
        this.handleTouchEvent({ event });
        this.dragInfo.isDragging = false;
      }

      this.dragInfo.isDown = false;
      this.isHorizontalDrag = false;
      this.dragX = 0;
      this.dragY = 0;
      this.touchEvent = null;

      if (this.isMobile) {
        this.isHorizontalDrag = false;
      }
    },

    stopDragging() {
      this.dragInfo.isDown = false;
      setTimeout(() => {
        this.dragInfo.isDragging = false;
      }, 100);
    },

    dragging(e, slidingContainer) {
      if (!this.dragInfo.isDown) return;
      let pageX = e.pageX ? e.pageX : e.touches[0].pageX;
      let pageY = e.pageY ? e.pageY : e.touches[0].pageY;
      this.dragInfo.isDragging = true;
      const x = pageX - slidingContainer.offsetLeft;
      this.dragInfo.startY = pageY - slidingContainer.offsetTop;
      const walk = x - this.dragInfo.startX;
      slidingContainer.scrollLeft = this.dragInfo.scrollLeft - walk;
    },

    startDragging(e, slidingContainer) {
      this.dragInfo.isDown = true;
      let pageX = e.pageX ? e.pageX : e.touches[0].pageX;
      this.dragInfo.startX = pageX - slidingContainer.offsetLeft;
      this.dragInfo.scrollLeft = slidingContainer.scrollLeft;
    },

    moveVideoWhenGrowing(index) {
      const isVideoLarge =
        this.videos[index].width / this.videos[index].height > 0.99;

      const canVideoGrowLarger =
        this.numberOfVideosToDisplay -
          (index - this.indexOfFirstVideoDisplayed) <
        2;
      isVideoLarge && (this.isBiggerVideoPlaying = true);
      if (isVideoLarge && canVideoGrowLarger) {
        this.indexOfFirstVideoDisplayed = this.clickedIndex;
      }
    },
    toggleFullScreen(videoIndex) {
      if (videoIndex == null) return;
      if (this.dragX === 0 && !this.dragInfo.isDragging) {
        this.clickedInlineIndex = videoIndex;
        this.$emit("open-full-screen", videoIndex);
      }
    },
    goToPreviousVideo(currentIndex) {
      if (currentIndex > 0) {
        const newIndex = currentIndex - 1;
        this.clickedInlineIndex = newIndex;
        this.setCurrentIndex(newIndex);
      }
    },
    goToNextVideo(currentIndex) {
      const newIndex = currentIndex + 1;
      this.setCurrentIndex(newIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
.sliding-wrapper {
  height: 100%;
  display: grid;
  max-width: 100%;
  gap: 16px;
  .arrow {
    z-index: $index-icon-position;
    background: transparent;
    cursor: pointer;
    &.--prev {
      transform: scale(1.2) rotate(180deg);
    }
    &.--next {
      transform: scale(1.2);
    }
  }
}

.sliding-wrapper.hideArrows {
  gap: 0;
}

.vidjet-carousel-items {
  display: grid;
  place-items: center;
  gap: 16px;
  overflow: hidden;
  max-width: 100%;
  cursor: pointer;
}
.vidjet-carousel-items.is-story {
  cursor: auto !important;
  align-items: start;
}
.video-not-selectable {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.video-not-selectable-stories-mobile {
  width: 90px;
}

.has-shadow {
  padding: 10px 0;
}
.sliding-wrapper {
  position: relative;
}

.vidjet-carousel-items {
  position: relative;
  display: grid;
  place-items: center;
  gap: 16px;
  overflow-x: auto;
  overflow-y: visible;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.overlay-arrows {
  position: absolute;
  inset: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  pointer-events: none;
  z-index: $index-icon-position + 1;
  padding-inline: var(--overlayPad, 16px);
}

.arrow.--overlay {
  pointer-events: auto;
  align-self: center;
  background: transparent;
  cursor: pointer;
  transform: scale(1.2);
}

.arrow.--overlay.--prev {
  justify-self: start;
  transform: scale(1.2) rotate(180deg);
}
.arrow.--overlay.--next {
  justify-self: end;
  transform: scale(1.2);
}
</style>
